import React from 'react';
import SignInForm from 'components/auth/SignInForm';

const SignInPage = () => {
    return (
        <SignInForm />
    );
};

export default SignInPage;
